import { sanitizeHTML } from '@/lib/utils'

interface SecFaqsProps {
	id: number
	heading?: {
		title?: string
	}
	content_collection?: {
		id: number
		site_content_collections_id: {
			title: string
			collection: {
				item: {
					title?: string // from site_content.title
					text?: string // from site_content.text
				}
			}[]
		}
	}[]
}

export const fields = [
	'heading.title',

	'content_collection.id',
	'content_collection.site_content_collections_id.collection.item:site_content.title',
	'content_collection.site_content_collections_id.collection.item:site_content.text',
]
export default function SecFaqs({ data }: { data: SecFaqsProps }) {
	// Helper to render a single FAQ item
	const renderFaqItem = (faq: any) => {
		const titleItem = faq.site_content_collections_id.collection.find(c => c.item.title)?.item
		const textItem = faq.site_content_collections_id.collection.find(c => c.item.text)?.item

		return (
			<div key={faq.id} className='mb-12 break-inside-avoid space-y-6'>
				<h3>{titleItem?.title || faq.site_content_collections_id.title || ''}</h3>
				<div
					className='grid gap-8'
					dangerouslySetInnerHTML={sanitizeHTML(textItem?.text || '')}
				/>
			</div>
		)
	}

	return (
		<section id='faqs' className='SecFaqs py-16 2xl:py-32'>
			<div className='container'>
				<h2 className='text-center mb-12 md:mb-20'>
					{data?.heading?.title || 'Frequently Asked Questions'}
				</h2>

				<div className='columns-1 lg:columns-2 lg:gap-24'>
					{(data?.content_collection || []).map(faq => renderFaqItem(faq))}
				</div>
			</div>
		</section>
	)
}
